import { Box, Shimmer } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { Link } from "react-router-dom"
import styled from "styled-components"

const StyledBreadcrumb = styled(Box).attrs({
  as: "ol",
  fontSize: "14px",
  overflowX: { _: "auto", tablet: "hidden" },
  px: 0,
  py: 3,
})`
  color: #757575;
  font-weight: 300;
  line-height: 14px;
  list-style: none;
  li {
    display: inline-flex;
  }
  li + li:before {
    content: "/";
    padding: 0 4px;
  }
  white-space: nowrap;
`

const Breadcrumb = ({ article, isLoading }) => {
  return (
    <nav aria-label="Breadcrumb">
      <StyledBreadcrumb>
        <li>
          <Link data-lc="breadcrumb" to="/">
            Home
          </Link>
        </li>
        <li>
          {article ? (
            <Link data-lc="breadcrumb" to="/blog">
              {sl.config.site_title} Blog
            </Link>
          ) : (
            <>{sl.config.site_title} Blog</>
          )}
        </li>
        {isLoading ? (
          <li>
            <Shimmer display="inline-block" height="14px" width="360px" />
          </li>
        ) : (
          article && <li>{article}</li>
        )}
      </StyledBreadcrumb>
    </nav>
  )
}

Breadcrumb.propTypes = {
  article: PropTypes.string,
  isLoading: PropTypes.bool,
}

export default Breadcrumb
